/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "l2Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "depositsEnabled",
                type: "bool",
            },
        ],
        name: "DepositsEnabled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "depositId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "l1Recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "l2Sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "l2Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "slowRelayFeePct",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "instantRelayFeePct",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "quoteTimestamp",
                type: "uint64",
            },
        ],
        name: "FundsDeposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "newMinimumBridgingDelay",
                type: "uint64",
            },
        ],
        name: "SetMinimumBridgingDelay",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "l2Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "numberOfTokensBridged",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "l1Gas",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "TokensBridged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "l2Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "lastBridgeTime",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "address",
                name: "bridgePool",
                type: "address",
            },
        ],
        name: "WhitelistToken",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l2Token",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "l2Gas",
                type: "uint32",
            },
        ],
        name: "bridgeTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l2Token",
                type: "address",
            },
        ],
        name: "canBridge",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Recipient",
                type: "address",
            },
            {
                internalType: "address",
                name: "l2Token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "slowRelayFeePct",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "instantRelayFeePct",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "quoteTimestamp",
                type: "uint64",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l2Token",
                type: "address",
            },
        ],
        name: "isWhitelistToken",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "l1Weth",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minimumBridgingDelay",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "numberOfDeposits",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "time",
                type: "uint256",
            },
        ],
        name: "setCurrentTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "timerAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "whitelistedTokens",
        outputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                internalType: "address",
                name: "l1BridgePool",
                type: "address",
            },
            {
                internalType: "uint64",
                name: "lastBridgeTime",
                type: "uint64",
            },
            {
                internalType: "bool",
                name: "depositsEnabled",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
export class BridgeDepositBox__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
BridgeDepositBox__factory.abi = _abi;
